import { puzzleId } from "./common/daily.js";
import { setClass } from "./dom.js";
import "./common/dark.js";

document.getElementById('main-menu-button').addEventListener('click',
	() => document.getElementById('close-instructions').innerHTML = "Close");

export function openModal(id) {
	document.getElementById(id).showModal();
}

export function closeModal(id) {
	document.getElementById(id).close();
}

for (const el of document.querySelectorAll('button[data-modal]'))
	el.addEventListener('click', e => openModal(el.dataset.modal));

let text, url;
document.getElementById('submit').addEventListener('click', e => {
	const walls = document.getElementById('best').innerText;
	text = `I completed #Celtix ${puzzleId} using ${walls} walls.`;
	url = `http://www.andrewt.net/puzzles/celtix?p=${puzzleId}`;
	document.getElementById('share-preview').innerText = text;
});
const shareNative = document.getElementById('share-native');
setClass(shareNative, 'hidden', !navigator.share);
shareNative.addEventListener('click', e => navigator.share({ title: "Celtix", text, url }));
document.getElementById('share-clipboard').addEventListener('click', () =>
	navigator.clipboard.writeText(`${text}\n\n${url}`));
